module.exports = __webpack_public_path__ + "img/main-location-icon3.1bc9fc8a.svg";